import { Vendor } from './vendor.model';

export type GiftcardDelivery = {
  targetAddress: string;
  deliveryStatus: OrderDeliveryStatus;
  channel: OrderDeliveryChannel;
  gifting?: GiftCardGiftingRequest;
  metadata?: any;
  receiptId?: string;
};
export type GiftCardGiftingRequest = {
  recipientEmail: string;
  recipientEmailVerification: string;
  recipientName: string;
  message: string;
  deliveryDate?: string;
  messageImageURL?: string;
};

export enum OrderDeliveryStatus {
  ATTEMPTED = 'ATTEMPTED',
  DELIVERED = 'DELIVERED',
  BOUNCED = 'BOUNCED',
  FAILED = 'FAILED',
}

export enum OrderDeliveryChannel {
  EMAIL = 'EMAIL',
  ON_THE_SPOT = 'ON_THE_SPOT',
}

export enum OrderStatus {
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  FAILED_WITH_RETRY = 'FAILED_WITH_RETRY',
  SUCCESS = 'SUCCESS',
  PENDING_NO_RETRY = 'PENDING_NO_RETRY',
  PENDING_FULFILLMENT = 'PENDING_FULFILLMENT',
}

export interface CheckoutRequest {
  price: string;
  cardName: string;
  cardId: string;
  imageUri: string;
  vendor: Vendor;
  redirectUri: string;
  merchantId: string;
  gifting?: GiftCardGiftingRequest;
}

export interface CheckoutResponse {
  result: CheckoutResult;
  order: CheckoutOrder;
}

export interface CheckoutResult {
  id: string;
  uri: string;
  checkout_id: string;
  redirect_uri: string;
}

export interface CheckoutOrder {
  id: string;
  vendor: Vendor;
  zipStatus: OrderStatus;
  price: number;
  isGifting: boolean;
  createdAt: string;
}

export interface CheckoutEvent {
  isGifting?: boolean;
}
